var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.654,
    height: 26.664,
    viewBox: "0 0 26.654 26.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1413",
    "data-name": "Rectangle 1413",
    width: 26.654,
    height: 26.664,
    fill: "#0000b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M2.05,24.614v-.433q0-9.4,0-18.8c0-.9.361-1.265,1.257-1.265H6.151c0-.87.034-1.712-.008-2.55C6.082.372,6.517-.01,7.7,0c3.834.034,7.668.013,11.5.013.955,0,1.3.351,1.3,1.318,0,.916,0,1.831,0,2.782h1.33c.577,0,1.153-.006,1.73,0A1.023,1.023,0,0,1,24.6,5.149c0,.021,0,.043,0,.064q0,8.12,0,16.24a1.028,1.028,0,1,1-2.049-.007q0-7.431,0-14.863v-.4H20.52v18.43h.336q2.323,0,4.646,0a1.031,1.031,0,1,1,.013,2.049H1.134a1.029,1.029,0,1,1-.009-2.049c.3,0,.593,0,.925,0M8.2,2.08v.4q0,9.385,0,18.77c0,.117,0,.235,0,.352a1.023,1.023,0,0,1-2.024.139,2.119,2.119,0,0,1-.022-.414q0-7.383,0-14.766V6.186H4.116V24.594h6.136c0-1.021,0-2.023,0-3.024A1.009,1.009,0,0,1,11.3,20.516q2.018-.01,4.037,0A1.018,1.018,0,0,1,16.4,21.589c.006.865,0,1.73,0,2.595v.408h2.035V2.08ZM12.316,24.6h2.017V22.587H12.316Z",
    transform: "translate(0 0)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1405",
    "data-name": "Rectangle 1405",
    width: 2.011,
    height: 2.01,
    transform: "translate(10.266 4.13)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1406",
    "data-name": "Rectangle 1406",
    width: 2.018,
    height: 2.012,
    transform: "translate(14.372 4.129)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1407",
    "data-name": "Rectangle 1407",
    width: 2.012,
    height: 2.01,
    transform: "translate(10.274 8.228)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1408",
    "data-name": "Rectangle 1408",
    width: 2.022,
    height: 1.999,
    transform: "translate(14.374 8.24)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1409",
    "data-name": "Rectangle 1409",
    width: 2.011,
    height: 2.016,
    transform: "translate(10.268 12.327)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1410",
    "data-name": "Rectangle 1410",
    width: 2.011,
    height: 2.01,
    transform: "translate(14.37 12.339)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1411",
    "data-name": "Rectangle 1411",
    width: 2.008,
    height: 2.022,
    transform: "translate(10.27 16.429)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1412",
    "data-name": "Rectangle 1412",
    width: 2.008,
    height: 2.022,
    transform: "translate(14.371 16.429)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnits);
export default __webpack_public_path__ + "static/media/units.7e5376c4bedc87cce59ee952a8087cc2.svg";
export { ForwardRef as ReactComponent };